import { useSpinnerVisible } from '@hooks/useSpinnerVisible';
import { Spinner } from '@sharedComponents/Spinner';
import { PropsLayout } from '@app/Layout/PropsLayout';
import { ScriptsPage } from '../ScriptsPage';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { useEffect } from 'react';
import { getAllInfoProduct } from '@redux/slices/ProductManagement';
import { getAuthUserData } from '@app/entities/Auth';
import { ServiceEcommerce2 } from '@app/services/ServiceEcommerce';
import Head from 'next/head';
import config from '@app/config';
import { sanitizeUrl } from '@sharedHelpers/sanitizeUrl';

export const WrapperLayout = ({ children, title = 'Колесо', metaData = [], page }: PropsLayout): JSX.Element => {
  const user = useAppSelector(getAuthUserData);
  const visible = useSpinnerVisible();
  const urlPage = typeof window !== 'undefined' ? window.location.href : null;
  const canonical = metaData.find(x => x?.name === 'canonical');
  const dispatch = useAppDispatch();
  const region = useAppSelector(state => state.header.data.region);
  useEffect(() => {
    dispatch(getAllInfoProduct(+region?.REGION));
    if (user?.isLoggedin) {
      ServiceEcommerce2.user(user?.userId);
    }
  }, []);

  return (
    <>
      <Head>
        <title>{title}</title>
        {metaData
          ?.filter(meta => meta.name !== 'canonical')
          ?.map((meta, index) => <meta key={index} name={meta.name} content={meta.content} />)}
        <link rel="shortcut icon" href="/favicon.ico" type="image/x-icon" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={sanitizeUrl(urlPage)} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={metaData.find(x => x.name === 'description')?.content} />
        <meta name="twitter:image" content={`${config.baseImageUrl}/upload/medialibrary/logotipyi/15_2563.png`} />

        <meta property="og:locale" content="ru" />
        <meta property="og:site_name" content="koleso.ru" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={metaData.find(x => x.name === 'description')?.content} />
        <meta property="og:url" content={sanitizeUrl(urlPage)} />
        <meta property="og:image" content={`${config.baseImageUrl}/upload/medialibrary/logotipyi/15_2563.png`} />

        {canonical && <link rel="canonical" href={canonical?.content} />}

        <meta name="zen-verification" content="kDofMwVSaoLvBSo0cuA6FMSd2wRBqWtaAvqDPcmsb9m9Kli3eYmquZoVyLG2PSAz" />
      </Head>
      {page && <ScriptsPage page={page} />}
      {children}
      {visible && <Spinner />}
    </>
  );
};
